module.exports = __webpack_public_path__ + "static/media/wwx.f279403b.svg";